export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          精彩预告
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">
          即将上线的热门影片，抢先一睹为快
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Media 1 */}
          <div className="bg-background-50 border border-background-200/60 rounded-lg overflow-hidden group cursor-default">
            <div className="relative h-52 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20scene%20with%20massive%20spaceship%20fleet%20and%20distant%20planet%2C%20dramatic%20space%20battle%20with%20laser%20beams%20and%20explosions%2C%20dark%20cosmic%20background%20with%20neon%20blue%20and%20orange%20highlights%2C%20cinematic%20widescreen%20composition%2C%20professional%20movie%20visual%20effects%20style&width=800&height=520&seq=media-trailer-01&orientation=landscape"
                alt="星际之战：新纪元 预告片"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 object-top"
                width="800"
                height="520"
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                  <span className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-play-fill text-primary-500 group-hover:text-background-50 text-2xl ml-0.5 transition-colors"></i>
                  </span>
                </div>
              </div>
              <div className="absolute bottom-3 right-3 px-2 py-0.5 rounded bg-background-950/70 text-xs text-foreground-800">
                02:35
              </div>
            </div>
            <div className="p-5">
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-1">星际之战：新纪元</h3>
              <p className="text-xs text-foreground-500">科幻巨制 · 8月15日上线</p>
            </div>
          </div>

          {/* Media 2 */}
          <div className="bg-background-50 border border-background-200/60 rounded-lg overflow-hidden group cursor-default">
            <div className="relative h-52 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Intense%20action%20movie%20chase%20scene%20through%20a%20rainy%20neon-lit%20city%20street%20at%20night%2C%20dramatic%20cinematic%20lighting%20with%20red%20and%20blue%20police%20lights%2C%20fast%20cars%20and%20explosions%2C%20gritty%20urban%20atmosphere%2C%20professional%20movie%20cinematography%20style&width=800&height=520&seq=media-trailer-02&orientation=landscape"
                alt="暗夜追缉 预告片"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 object-top"
                width="800"
                height="520"
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                  <span className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-play-fill text-primary-500 group-hover:text-background-50 text-2xl ml-0.5 transition-colors"></i>
                  </span>
                </div>
              </div>
              <div className="absolute bottom-3 right-3 px-2 py-0.5 rounded bg-background-950/70 text-xs text-foreground-800">
                01:48
              </div>
            </div>
            <div className="p-5">
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-1">暗夜追缉</h3>
              <p className="text-xs text-foreground-500">动作犯罪 · 8月22日上线</p>
            </div>
          </div>

          {/* Media 3 */}
          <div className="bg-background-50 border border-background-200/60 rounded-lg overflow-hidden group cursor-default">
            <div className="relative h-52 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Heartwarming%20animated%20movie%20scene%20with%20colorful%20fantasy%20landscape%20and%20magical%20creatures%2C%20soft%20dreamy%20lighting%20with%20sparkles%20and%20glowing%20elements%2C%20vibrant%20coral%20and%20teal%20color%20palette%2C%20whimsical%20adventure%20atmosphere%2C%20professional%20animation%20movie%20visual%20style&width=800&height=520&seq=media-trailer-03&orientation=landscape"
                alt="梦幻岛大冒险 预告片"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 object-top"
                width="800"
                height="520"
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                  <span className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-play-fill text-primary-500 group-hover:text-background-50 text-2xl ml-0.5 transition-colors"></i>
                  </span>
                </div>
              </div>
              <div className="absolute bottom-3 right-3 px-2 py-0.5 rounded bg-background-950/70 text-xs text-foreground-800">
                03:12
              </div>
            </div>
            <div className="p-5">
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-1">梦幻岛大冒险</h3>
              <p className="text-xs text-foreground-500">动画奇幻 · 8月30日上线</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}